import axios from 'axios'

var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']

function getDestinationType(to) {
  if (to.name === 'single-product') {
    return 'product'
  }
  if (to.name === 'product-cats' || to.name === 'user-product-cats') {
    return 'category'
  }
  return 'other'
}

function getDestinationPage(to) {
  if (to.name === 'single-product') {
    return to.params.productSlug || ''
  }
  if (to.name === 'product-cats' || to.name === 'user-product-cats') {
    var slugParts = to.params.fullSlug
    return Array.isArray(slugParts) ? slugParts.join('/') : (slugParts || '')
  }
  return to.path
}

function extractUtmParams(query) {
  var params = {}
  var hasUtm = false

  UTM_PARAMS.forEach(function(param) {
    if (query[param]) {
      params[param] = query[param]
      hasUtm = true
    }
  })

  return hasUtm ? params : null
}

function trackUtmVisit(to, utmParams) {
  try {
    var trackingData = {
      destination_page: getDestinationPage(to),
      destination_type: getDestinationType(to),
      utm_source: utmParams.utm_source,
      utm_medium: utmParams.utm_medium,
      utm_campaign: utmParams.utm_campaign,
      utm_content: utmParams.utm_content
    }

    // Fire-and-forget
    axios.post('/api/utm-tracking', trackingData).catch(function(err) {
      console.warn('[UTM Tracking] Failed:', err.message)
    })
  } catch (err) {
    console.warn('[UTM Tracking] Error:', err.message)
  }
}

export function utmTrackingMiddleware(to, from, next) {
  var utmParams = extractUtmParams(to.query)

  if (utmParams) {
    trackUtmVisit(to, utmParams)
  }

  next()
}